<template>
  <tbody>
    <!-- No records row -->
    <tr v-if="!rows.records || rows.records.length < 1">
      <td :colspan="colSpan" align="center">No records found.</td>
    </tr>

    <tr v-for="row in rows.records" :key="row.member_id">
      <td>{{ row.member_id }}</td>

      <td>
        <div class="yellow-section">
          <div class="info-row">
            <strong>Name: </strong>
            <span class="member-name">{{ row.member_name }}</span>
            <span
              v-if="row.age_flag === 'member' || row.age_flag === 'both'"
              class="pill-red"
              >65+</span
            >
          </div>
          <div class="info-row">
            <strong>Email: </strong>
            <span>{{ row.email || "-" }}</span>
          </div>
          <div class="info-row">
            <strong>Phone: </strong>
            <span>{{ row.phone || "-" }}</span>
          </div>
        </div>
      </td>

      <td>{{ row.birth_date }}</td>

      <td>
        {{ row.spouse_name || "-" }}
        <span
          v-if="row.age_flag === 'spouse' || row.age_flag === 'both'"
          class="pill-red"
          >65+</span
        >
      </td>

      <td>{{ row.spouse_birth_date || "-" }}</td>

      <td>
        <div class="yellow-section">
          <div class="info-row">
            <strong>Name: </strong>
            <span class="rep-name">{{ row.rep_full_name }}</span>
          </div>
          <div class="info-row">
            <strong>Email: </strong>
            <span>{{ row.rep_email || "-" }}</span>
          </div>
          <div class="info-row">
            <strong>Phone: </strong>
            <span>{{ row.rep_phone || "-" }}</span>
          </div>
        </div>
      </td>
  <td>
    <span v-if="Array.isArray(row.group_name)">
      <span v-for="(group, index) in row.group_name" :key="index" class="groups">
        {{ group }}
      </span>
    </span>
    <span v-else>
      {{ row.group_name }}
    </span>
  </td>


      <td>
        <span v-for="plan in row.plan_name" :key="plan" class="plans">
          {{ plan }}
        </span>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: "ActiveMemeberL713Table",
  props: {
    rows: {
      type: Object,
      required: true,
    },
    colSpan: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.plans {
  display: block;
  margin-bottom: 3px;
}

.pill-red {
  background-color: #028f02;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 5px;
  border-radius: 10px;
  margin-left: 5px;
  display: inline-block;
}

.yellow-section {
  background-color: #fff3cd;
  padding: 4px 8px;
  border-radius: 6px;
  margin-top: 4px;
  display: inline-block;
  font-size: 12px;
  color: #333;
  line-height: 1.4;
  border: 1px solid #ffeeba;
  width: 100%;
}

.info-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 2px;
}

.member-name {
  font-weight: bold;
  font-size: 14px;
  color: #0275d8;
  margin-left: 4px;
  word-break: break-word;
}

.rep-name {
  font-weight: bold;
  font-size: 14px;
  color: #d9534f;
  margin-left: 4px;
  word-break: break-word;
}
.groups {
  display: block;
  margin-bottom: 3px;
}


</style>
